module.exports = __webpack_public_path__ + "static/media/18.4843e478.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/18.png
// module id = 1259
// module chunks = 0